import { render, staticRenderFns } from "./add-form-component.vue?vue&type=template&id=5c4f61d9&scoped=true"
import script from "./add-form-component.vue?vue&type=script&lang=js"
export * from "./add-form-component.vue?vue&type=script&lang=js"
import style0 from "./add-form-component.vue?vue&type=style&index=0&id=5c4f61d9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4f61d9",
  null
  
)

export default component.exports